import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewportService } from 'src/app/shared/services/viewport.service';
import { dividerBackgroundColor } from 'src/app/shared/types/divider-background-color.type';

@Component({
  selector: 'app-modal-table-description',
  templateUrl: './modal-table-description.component.html',
  styleUrls: ['./modal-table-description.component.scss']
})
export class ModalTableDescriptionComponent implements OnInit, OnDestroy {
  @ViewChild('openDescriptionModal') openModal: ElementRef;

  @Input() modalId = 'modal-description-detail';
  @Input() cardLayoutForMobile = true;

  private isDesktopSubscription: Subscription;
  public isDesktop: boolean;

  title: string;
  data: string;

  public readonly dividerBackgroundColor: dividerBackgroundColor = 'highlight-grey-darker';

  constructor(private viewportService: ViewportService) {}

  ngOnInit(): void {
    this.isDesktopSubscription = this.viewportService.isDesktopObservable.subscribe((value) => {
      this.isDesktop = value;
    });
  }

  ngOnDestroy() {
    if (this.isDesktopSubscription) {
      this.isDesktopSubscription.unsubscribe();
    }
  }

  get bsTarget() {
    return `#${this.modalId}`;
  }

  public open(title: string, data: string) {
    this.title = title;
    this.data = data;

    this.openModal.nativeElement.click();
  }

  getBodyClass() {
    return this.isDesktop || !this.cardLayoutForMobile ? 'modal-description-body' : 'modal-description-body-mobile';
  }

  getNoDescriptionText() {
    return this.title ? 'Não há informação de ' + this.title.toLowerCase() + '!' : 'Sem informação';
  }
}
